<template>
    <breadcrumb/>
    <section class="py-5">
        <div v-if="data.success" class="container">
            <h1>در حال انتقال به درگاه بانک</h1>
            <form id="redirect-to-bank" :action="data.redirect" :method="data.method">
                <input v-for="(value, key) in data.parameters" type="hidden" :name="key" :value="value">
                <button type="submit" class="opacity-0"></button>
            </form>
        </div>
        <div v-else class="container">
            <h1>خطا در اتصال به درگاه پرداخت</h1>
            <p>خطایی در اتصال به درگاه بانک به وجود آمده. لطفا مجددا تلاش کنید.</p>
            <a class="btn btn-primary px-3 text-white" :href="`/checkout/${data.bill.data.uuid}`">تلاش دوباره
            </a>
        </div>
    </section>

</template>

<script>
import Breadcrumb from "../../Components/Breadcrumb";
import {Link} from "@inertiajs/inertia-vue3";

export default {
    components: {
        Breadcrumb, Link,
    },
    props: {
        data: {
            type: Object,
        }
    },
    data() {
        return {}
    },
    mounted() {
        if (this.data.success) {
            document.getElementById('redirect-to-bank').submit()
        }
    }
}
</script>

<style scoped>

</style>
